(function(){
  var $=function(s,c){return (c||document).querySelector(s)}, $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};
  var bg=$('.ly-drawer-bg');
  function openBg(){bg&&bg.classList.add('is-open');document.documentElement.style.overflow='hidden'}
  function closeAll(){ $$('.ly-menu,.ly-cart,.ly-search').forEach(function(e){e.classList.remove('is-open')}); bg&&bg.classList.remove('is-open'); document.documentElement.style.overflow=''}
  bg&&bg.addEventListener('click',closeAll);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeAll();$$('.ly-modal').forEach(function(m){m.classList.remove('is-open')})}});
  $$('[data-open-menu]').forEach(function(b){b.addEventListener('click',function(){$('.ly-menu').classList.add('is-open');openBg()})});
  $$('[data-open-search]').forEach(function(b){b.addEventListener('click',function(){$('.ly-search').classList.add('is-open');openBg();setTimeout(function(){var i=$('.ly-search input');i&&i.focus()},200)})});
  $$('[data-close]').forEach(function(b){b.addEventListener('click',closeAll)});

  /* ---------- Panier ---------- */
  var cartEl=$('.ly-cart'), money=function(c){return (c/100).toFixed(2).replace('.',',')+' €'};
  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
  function setCount(n){$$('.ly-cnt').forEach(function(e){e.textContent=n;e.setAttribute('data-n',n)})}
  function render(cart){
    setCount(cart.item_count);
    if(!cartEl) return;
    var box=$('.ly-cart__items',cartEl), ft=$('.ly-cart__ft',cartEl);
    if(!cart.item_count){box.innerHTML='<div class="ly-cart__empty"><p>Votre panier est vide.</p><a class="ly-btn" href="/products/legging-sculptant-3d">Découvrir le legging</a></div>';ft.style.display='none';return}
    ft.style.display='';
    box.innerHTML=cart.items.map(function(it,i){
      var props='';
      if(it.properties){for(var k in it.properties){if(k.charAt(0)!=='_'&&it.properties[k]) props+='<div class="ly-ci__v">'+esc(k)+' : '+esc(it.properties[k])+'</div>'}}
      var img=it.image?'<img src="'+it.image+(it.image.indexOf('?')>-1?'&':'?')+'width=200" alt="">':'';
      var cmp=(it.original_line_price>it.final_line_price)?'<s>'+money(it.original_line_price)+'</s>':'';
      return '<div class="ly-ci"><div class="ly-ci__img">'+img+'</div><div><a class="ly-ci__t" href="'+it.url+'">'+esc(it.product_title)+'</a>'+
        (it.variant_title?'<div class="ly-ci__v">'+esc(it.variant_title)+'</div>':'')+props+
        '<div class="ly-ci__q"><button type="button" data-q="'+(i+1)+'" data-v="'+(it.quantity-1)+'" aria-label="Retirer un">−</button><span>'+it.quantity+'</span><button type="button" data-q="'+(i+1)+'" data-v="'+(it.quantity+1)+'" aria-label="Ajouter un">+</button></div></div>'+
        '<div class="ly-ci__p">'+money(it.final_line_price)+cmp+'<br><button type="button" class="ly-ci__rm" data-q="'+(i+1)+'" data-v="0">Retirer</button></div></div>';
    }).join('');
    $('.ly-cart__sub',cartEl).textContent=money(cart.total_price);
  }
  function getCart(){return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()})}
  function refresh(){return getCart().then(render)}
  function openCart(){refresh();cartEl&&cartEl.classList.add('is-open');openBg()}
  window.lyOpenCart=openCart;
  $$('[data-open-cart]').forEach(function(b){b.addEventListener('click',function(e){if(cartEl){e.preventDefault();openCart()}})});
  cartEl&&cartEl.addEventListener('click',function(e){
    var b=e.target.closest('[data-q]'); if(!b) return;
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line:+b.dataset.q,quantity:+b.dataset.v})}).then(function(r){return r.json()}).then(render);
  });
  refresh();

  /* ---------- Offres ---------- */
  $$('[data-ly-offer]').forEach(function(form){
    var data=JSON.parse($('script[data-variants]',form).textContent);
    var cards=$$('.ly-off',form), idIn=$('input[name=id]',form), btn=$('.ly-atc',form), err=$('.ly-err',form);
    function sel(card){
      cards.forEach(function(c){c.classList.toggle('is-sel',c===card); var r=$('input[type=radio]',c); if(r) r.checked=(c===card)});
      update();
    }
    function update(){
      var card=$('.ly-off.is-sel',form); if(!card) return;
      var offer=card.dataset.offer, sizes=$$('select[data-size]',card).map(function(s){return s.value});
      var v=data.filter(function(x){return x.o1===offer&&x.o2===sizes[0]})[0];
      if(v) idIn.value=v.id;
      var pi=$('input[name="properties[Tailles]"]',form);
      if(pi){ pi.value = sizes.length>1 ? sizes.map(function(s,i){return 'Paire '+(i+1)+' : '+s}).join(' · ') : ''; pi.disabled = sizes.length<2; }
      var sp=$('[data-sticky-price]'); if(sp&&v){sp.textContent=money(v.p)}
    }
    cards.forEach(function(c){
      c.addEventListener('click',function(e){ if(e.target.closest('select')) return; if(!c.classList.contains('is-sel')) sel(c) });
    });
    $$('select[data-size]',form).forEach(function(s){s.addEventListener('change',update)});
    update();
    form.addEventListener('submit',function(e){
      e.preventDefault(); btn.disabled=true; err.style.display='none';
      (function(){
        var card=$('.ly-off.is-sel',form), n=$$('select[data-size]',card).length, gj=$('script[data-gifts]',form), g=gj?JSON.parse(gj.textContent):{};
        var main={id:+idIn.value,quantity:1,properties:{}}; var pi=$('input[name="properties[Tailles]"]',form); if(pi&&!pi.disabled&&pi.value) main.properties['Tailles']=pi.value;
        var items=[main];
        var gs=$('select[data-gift-size]',card); if(n>=2&&gs) items.push({id:+gs.value,quantity:1,properties:{'_cadeau':'Offert avec '+n+' paires'}});
        if(n>=3&&g.sleeve) items.push({id:g.sleeve,quantity:1,properties:{'_cadeau':'Offert avec 3 paires'}});
        if(n>=2&&g.bon) items.push({id:g.bon,quantity:1,properties:{'_cadeau':'Offert avec '+n+' paires'}});
        return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items})});
      })().then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j}})}).then(function(res){
        btn.disabled=false;
        if(!res.ok){err.textContent=res.j.description||res.j.message||'Ajout impossible pour le moment.';err.style.display='block';return}
        openCart();
      }).catch(function(){btn.disabled=false;err.textContent='Ajout impossible pour le moment.';err.style.display='block'});
    });
  });

  /* ---------- Galerie ---------- */
  $$('.ly-gal').forEach(function(g){
    var main=$('.ly-gal__main',g), th=$$('.ly-gal__t',g), tt=$('.ly-gal__tt',g);
    function go(i){var s=main.children[i]; if(s) main.scrollTo({left:s.offsetLeft-main.offsetLeft,behavior:'smooth'})}
    th.forEach(function(t,i){t.addEventListener('click',function(){go(i)})});
    main.addEventListener('scroll',function(){var w=main.children[0]?main.children[0].getBoundingClientRect().width:1;var i=Math.round(main.scrollLeft/w);th.forEach(function(t,j){t.classList.toggle('is-active',i===j)})},{passive:true});
    $$('.ly-gal__arr',g).forEach(function(a){a.addEventListener('click',function(){tt.scrollBy({left:(a.dataset.dir==='p'?-1:1)*tt.clientWidth*.6})})});
  });

  /* ---------- Onglets ---------- */
  $$('.ly-tabs').forEach(function(t){
    var bs=$$('.ly-tabs__b',t), ps=$$('.ly-tabs__p',t);
    bs.forEach(function(b,i){b.addEventListener('click',function(){bs.forEach(function(x,j){x.classList.toggle('is-active',i===j)});ps.forEach(function(x,j){x.classList.toggle('is-active',i===j)})})});
  });

  /* ---------- Comparaison ---------- */
  $$('.ly-cmp__box').forEach(function(b){
    var r=$('input',b), top=$('.ly-cmp__top',b), bar=$('.ly-cmp__bar',b);
    r.addEventListener('input',function(){var v=r.value;top.style.clipPath='inset(0 '+(100-v)+'% 0 0)';bar.style.left=v+'%'});
  });

  /* ---------- Modale tailles ---------- */
  $$('[data-open-size]').forEach(function(b){b.addEventListener('click',function(){var m=$('#ly-size');m&&m.classList.add('is-open')})});
  $$('.ly-modal').forEach(function(m){m.addEventListener('click',function(e){if(e.target===m||e.target.closest('[data-close-modal]'))m.classList.remove('is-open')})});

  /* ---------- CTA vers l'offre ---------- */
  $$('[data-to-offer]').forEach(function(a){a.addEventListener('click',function(e){var t=$('.ly-offers');if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth',block:'center'})}})});

  /* ---------- Barre collante ---------- */
  var st=$('.ly-sticky');
  if(st){
    var on=function(){var y=window.pageYOffset||0;st.setAttribute('data-visible',y>=parseInt(st.dataset.th||'4000',10)?'true':'false')};
    window.addEventListener('scroll',on,{passive:true});on();
    $('button',st).addEventListener('click',function(){var t=$('.ly-main');if(t){window.scrollTo({top:t.getBoundingClientRect().top+window.pageYOffset+(window.innerWidth<=600?250:100)-80,behavior:'smooth'})}});
  }

  /* ---------- Compte à rebours (fin de journée, heure de Paris) ---------- */
  var cd=$('.ly-ann__cd');
  if(cd){
    var h=$('[data-h]',cd),m=$('[data-m]',cd),s=$('[data-s]',cd);
    var tick=function(){var n=new Date();var p=new Date(n.toLocaleString('en-US',{timeZone:'Europe/Paris'}));var left=(24*3600)-(p.getHours()*3600+p.getMinutes()*60+p.getSeconds());
      var pad=function(x){return (x<10?'0':'')+x};h.textContent=pad(Math.floor(left/3600));m.textContent=pad(Math.floor(left%3600/60));s.textContent=pad(left%60)};
    tick();setInterval(tick,1000);
  }
})();

(function(){var h=document.querySelector('.shopify-policy__title h1');if(!h)return;
var m={'refund-policy':'Retours et remboursements','privacy-policy':'Politique de confidentialité','terms-of-service':'Conditions générales de vente','shipping-policy':'Politique de livraison','contact-information':'Coordonnées','legal-notice':'Mentions légales'};
var k=location.pathname.split('/').pop();if(m[k]){h.textContent=m[k];document.title=m[k]+' · Lissaya';}})();
